import update from 'immutability-helper';
import { createReducer } from '../../utils/redux/reducers.utils';
import {
  AUTH_LOGOUT,
  AVAILABLE_ORGANIZATIONS_UPDATE,
  ORGANIZATION_SELECTION_REQUIRED,
  ORGANIZATION_SELECTION_RESOLVED,
  ORGANIZATION_SELECTION_RESOLVING,
} from '../actions';
import { ORGANIZATION_SELECTION_STATUS } from '../../constants/organization-selection.constants';

const initialState = {
  organizations: [],
  // Deliberately not persisted — a killed app must not leave a stale gate behind.
  selectionStatus: ORGANIZATION_SELECTION_STATUS.IDLE,
};

const updateOrganization = (state, { organizations }) =>
  update(state, {
    $merge: { organizations },
  });

const setSelectionStatus = status => state =>
  update(state, {
    selectionStatus: { $set: status },
  });

const authLogout = () => {
  return initialState;
};

const actionsRepo = {
  [AVAILABLE_ORGANIZATIONS_UPDATE]: updateOrganization,
  [ORGANIZATION_SELECTION_RESOLVING]: setSelectionStatus(ORGANIZATION_SELECTION_STATUS.RESOLVING),
  [ORGANIZATION_SELECTION_REQUIRED]: setSelectionStatus(ORGANIZATION_SELECTION_STATUS.PENDING),
  [ORGANIZATION_SELECTION_RESOLVED]: setSelectionStatus(ORGANIZATION_SELECTION_STATUS.DONE),
  [AUTH_LOGOUT]: authLogout,
};

export default createReducer({ initialState, actionsRepo });
